export const apiConstants = {
    headers: {
        errorCode: "X-ERROR-CODE",
        errorId: "X-ERROR-ID",
        expirationCookieTime: "X-COOKIE-TIME",
        payloadError: "X-ERROR-PAYLOAD",
    },
};
